import { Directive } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
export class IonicSelectableHeaderTemplateDirective {
}
IonicSelectableHeaderTemplateDirective.ɵfac = function IonicSelectableHeaderTemplateDirective_Factory(t) { return new (t || IonicSelectableHeaderTemplateDirective)(); };
IonicSelectableHeaderTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IonicSelectableHeaderTemplateDirective, selectors: [["", "ionicSelectableHeaderTemplate", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IonicSelectableHeaderTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[ionicSelectableHeaderTemplate]'
            }]
    }], null, null); })();

